import { pages } from "@routes/pages";

import { LockerTypeItem } from "../LockerTypeItem";
import { typesManagementPageFor } from "../typesManagementPageFor";

export default typesManagementPageFor(LockerTypeItem, pages.lockerTypes, {
  size: "sm"
});
